import React from 'react';
import { TechnicalCoachCard } from '../shared/TechnicalCoachCard';
export const TechnicalTeamSection = () => {
  const coaches = [{
    name: 'Arash (Ari) Saif',
    role: 'System Design and AI Expert',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a8f27ef708b31e95d7c_image-1.png',
    company: 'Oracle',
    companyDomain: 'oracle.com',
    title: 'Sr Principal Engineer',
    bio: 'Ex-Google software engineer, Adjust Associate Professor at University of Southern California, PhD in Computer Engineering',
    specialties: ['System Design', 'Scalability', 'Cloud Architecture'],
    linkedin: 'https://www.linkedin.com/in/ourarash/'
  }, {
    name: 'Paul Kim',
    role: 'System Design Expert',
    company: 'Coupang',
    companyDomain: 'coupang.com',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a904cf99329118c54f4_image-4.png',
    title: 'Engineering Director',
    bio: 'Ex-Amazon Engineering Manager with deep expertise in systems architecture, backend design, and startup hiring bars',
    specialties: ['Technical Leadership', 'Algorithms', 'Data Structures', 'Problem Solving'],
    linkedin: 'https://www.linkedin.com/in/paul-kim-software/'
  }, {
    name: 'Fnu Jimmy',
    role: 'System Design & Technical Interviewing Coach',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a9000fccd0710900fd5_image-3.png',
    company: 'QXO',
    companyDomain: 'qxo.com',
    title: 'Staff Software Engineer',
    bio: 'Ex Principal Software Engineer @ Oracle, TA at Georgia Institute of Technology with almost 20 years of experience.',
    specialties: ['System Design', 'Cloud', 'Architecture'],
    linkedin: 'https://www.linkedin.com/in/fnujimmy/'
  }, {
    name: 'Lei Shi',
    role: 'System Design & Technical Interviewing Coach',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/684166417332056056a28670_leishi.jpeg',
    company: 'Facebook (Meta)',
    companyDomain: 'meta.com',
    title: 'Lead Software Engineer',
    bio: 'Lead software engineer at Meta for 8 years, with specialties in AI, ML, and Blockchain',
    specialties: ['Leadership', 'Machine Learning', 'System Design', 'Platform and Devops'],
    linkedin: 'https://www.linkedin.com/in/shileiwill/'
  }, {
    name: 'Pierre Antoine',
    role: 'Cloud Architecture Expert',
    company: 'Publicis Sapient',
    companyDomain: 'publicissapient.com',
    linkedin: 'https://www.linkedin.com/in/mbefokam/',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a90531f3b925be09e89_image-2.png',
    title: 'Principal Architect',
    bio: 'Ex-JP Morgan Chase Senior VP Lead Software Engineer',
    specialties: ['Microservices', 'APIs', 'Database Design']
  }, {
    name: 'Jeff Jackson',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a907160c4896037ed9b_image.png',
    role: 'Data Structures & Algorithms Expert',
    company: 'Duquesne University',
    companyDomain: 'duq.edu',
    title: 'PhD Professor and Department Chair',
    bio: '30 years of experience at Duquesne University chairing courses including Software Engineering, Web Technologies, Theory of Programming Languages, Numerical Analysis, Formal Languages, Data Structures',
    linkedin: 'https://www.linkedin.com/in/jeff-jackson-2b976916/',
    specialties: ['System Design', 'Data Structures', 'Algorithms']
  }, {
    name: 'Karthik Gajulapalli',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a9053a7b36f3a37b79a_image-5.png',
    role: 'Technical Screens & Pair Programming Expert',
    company: 'University of Central Florida',
    companyDomain: 'ucf.edu',
    specialties: ['Data Structures', 'Algorithms', 'System Design'],
    title: 'Assistant Professor',
    bio: 'Assitant professor in computer science, ex competitive coding engineer - helps engineers identify patterns in difficult algorithmic problems to solve them',
    linkedin: 'https://www.linkedin.com/in/kgajulapalli/',
    website: 'https://kgajulapalli.org/index.html'
  }, {
    name: 'John B Lent',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/6a1631ad3bfcfb5d751f6f12_1745898149793.jpeg',
    role: 'iOS System Design Expert',
    company: 'Apple',
    companyDomain: 'apple.com',
    title: 'Staff iOS Engineer',
    bio: 'ex-Uber, interviewing iOS engineering roles at Apple.',
    specialties: ['iOS', 'Swift', 'System Design'],
    linkedin: 'https://www.linkedin.com/in/jbakerlent/'
  }, {
    name: 'Darrell Ross',
    image: 'https://media.licdn.com/dms/image/v2/D5603AQFlqvL79stMVA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1686601762705?e=1787184000&v=beta&t=oK2M4vgg_Dc7xSb7-MaEeFur-F6eYI-uIZk4akyxK-w',
    role: 'Agentic AI Interviewing Expert',
    company: 'Axon',
    companyDomain: 'axon.com',
    title: 'Senior Site Reliability Engineer II (Staff)',
    bio: 'On interviewing panels with agentic AI interviews at Axon.',
    specialties: ['Agentic Coding', 'DevOps', 'Cloud Infrastructure'],
    linkedin: 'https://www.linkedin.com/in/darrellaross/'
  }];
  return <section className="w-full bg-gradient-to-br from-[#1a0d24] to-[#231232] py-24 border-t border-b border-[#6805DA]/20" data-id="element-213" data-mp="2mikfud35hzrz">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214" data-mp="2djz2cwcjday2">
        <div className="text-center mb-12" data-id="element-215" data-mp="2dhm9ho58pg68">
          <h2 className="text-4xl font-outfit font-bold mb-6 text-white" data-id="element-216" data-mp="2hkspvom2gnqf">
            Technical Coaching Team
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-217" data-mp="23mud2nne8zd1">
            Our specialized technical coaches ensure you're prepared for every
            aspect of the interview process.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5" data-id="element-218" data-mp="e5p0z0a7w4di">
          {coaches.map(coach => <TechnicalCoachCard key={coach.name} {...coach} data-id="element-219" data-mp="5c3nrldpav67" />)}
        </div>
      </div>
    </section>;
};